export default __webpack_public_path__ + "static/our_work-8f79ad2324ac3e39a891e44c68071e36.jpg";